import React, { useEffect, useState, useRef } from "react";

import { CKEditor } from "@ckeditor/ckeditor5-react";

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axiosInstanceAuthFormData from "../../apiInstances/axiosInstanceAuthFormData";

import { MdOutlineKeyboardBackspace } from "react-icons/md";

const DocxConverterEdit = (props) => {
  const {
    setSecond,
    setIsOpenEdit,
    savedContentEdit,
    docxContentEdit,
    setDocxContentEdit,
    editId,
    setIsOpen,
    dateVersion,
    second,
    isOpen,
    isOpenEdit,
    getViewallSubmitForm,
    setIsLoading,
    setDocxContent,
    setSavedContent,
    setMytemplateIDData,
    setShowAll,
  } = props;
  console.log("🚀 ~ DocxConverterEdit ~ date:", dateVersion);
  // const [docxContent, setDocxContent] = useState("");
  // const [savedContent, setSavedContent] = useState(""); // State to store saved content

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setDocxContentEdit(data);
  };

  const saveContent = () => {
    const formData = new FormData();
    formData.append("editId", editId);
    formData.append(
      "templete",
      new Blob([docxContentEdit], { type: "text/html" }),
      "content.html"
    );
    axiosInstanceAuthFormData
      .post(`edit_submitform/${editId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })

      .then((res) => {
        setIsOpenEdit(true);
        setSecond(false);
        setIsOpen(true);
        setIsLoading(true);
        setDocxContent("");
        setSavedContent("");
        setMytemplateIDData("");
        // getProceduresData();
        //getSopsData();
        // window.location.reload(false);
        getViewallSubmitForm();
        console.log(res);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <>
      <div className="m-8">
        <div
          className="text-xl font-bold font-sans text-[#22345C]  flex items-center gap-1 cursor-pointer"
          onClick={() => {
            setIsOpen(!isOpen); // Open the main view
            setSecond(false);
            setIsOpenEdit(true);
            // setIsOpen(true);
            // setDocxContentEdit(null);
            // window.location.reload(false);
            setDocxContent("");
            setSavedContent("");
            setMytemplateIDData("");
            // Add similar lines for other states
            if (!isOpenEdit) {
              setShowAll(true); // Display all recent files
            }
          }}
        >
          <MdOutlineKeyboardBackspace size={25} />
          Back
        </div>

        <div className="flex justify-between">
          <div>
            <h1 className="text-2xl font-bold font-sans mb-5 mt-5 text-[#22345C]">
              Title : {dateVersion?.data?.title}
            </h1>
          </div>
          <div className="mb-3 mt-3 space-y-1">
            <h1 className="text-xl font-bold font-sans text-[#22345C]">
              Version : {dateVersion?.data?.version}
            </h1>
            <h1 className="text-xl font-bold font-sans  text-[#22345C]">
              Last Edited : {dateVersion?.data?.date}
            </h1>
            <h1 className="text-xl font-bold font-sans  text-[#22345C]">
              Edited By : {dateVersion?.data?.edit_by}
            </h1>
          </div>
        </div>

        <CKEditor
          editor={ClassicEditor}
          data={docxContentEdit}
          onChange={handleEditorChange}
        />
        <div className="flex gap-2">
          <div>
            <button
              className="bg-[#22345C] gap-1 justify-end  text-[#FFFFFF] font-sans text-lg font-bold py-1 mt-5 px-4 rounded-[10px] inline-flex items-center"
              onClick={saveContent}
            >
              Save
            </button>
          </div>

          <div dangerouslySetInnerHTML={{ __html: savedContentEdit }}></div>
        </div>
      </div>
    </>
  );
};

export default DocxConverterEdit;
